export default {
  All: "All",
  Search: "Search",
  Transfer: "Transfer",
  AgentDirect: "Agent (Direct)",
  AgentQueue: "Agent (Queue)",
  Queue: "Queue",
  PleaseWait: "Please Wait",
  TransferHoldAgent: "Transfering the video call. Please wait.",
  TransferHoldAgentDetail:
    "If the transfer is not accepted by the other agent, you can continue the call by clicking the button below.",
  TransferHoldUser: "Your video call is being transferred. Please wait.",
  TransferHoldUserDetail: "Your call will be transferred shortly..",

  TransferBridgeNull: "There is no connection that can handle the transfer.",
};
